import {action, observable} from 'mobx';
import http from '../../http'

class BookingStudioPageStore {
    _routerStore;
    _authStore;
    @observable loading = true;
    @observable firstLoad = true;
    @observable is404 = false;
    @observable studioId = null;
    @observable bookingServiceType = 'web';
    @observable studio = null;
    @observable rooms = [];

    constructor(routerStore, authStore) {
        this._routerStore = routerStore
        this._authStore = authStore
    }

    load = async () => {
        let studioId = null;
        const pathArray = window.location.pathname.split('/');
        const arrLength = pathArray.length;
        if (arrLength === 5 && pathArray[3] === 'studio') {
            this.bookingServiceType = pathArray[2]
            studioId = pathArray[arrLength - 1]
        }

        if (this.firstLoad || studioId !== this.studioId) {
            Promise.resolve(() => true)
                .then(() => this.studioId = studioId)
                .then(() => this.firstLoad = false)
                .then(this.getStudioInfo)
                .then(this.getStudioRooms)
                .then(async () => setTimeout(
                    () => this.loading = false
                    , 300))
        }
    };

    @action
    getStudioInfo = () => {
        http.get(`/studio/${this.studioId}/view?serviceType=${this.bookingServiceType}`)
            .then(({data}) => {
                const responseContent = data.content;
                if (responseContent.length === 0) {
                    this.is404 = true;
                } else {
                    this.studio = responseContent;
                }
            })
            .catch(({response}) => {
                this.is404 = response && response.status === 404
            })
    };

    @action
    getStudioRooms = () => {
        http.get(`/studio/${this.studioId}/rooms?serviceType=${this.bookingServiceType}`)
            .then(({data}) => {
                this.rooms = data.content;
            })
    };

    @action
    addFavoriteRoom = (room) => {
        http.post(`/favorite-room/${room.id}/add`)
            .then(() => {
                room.is_favorite = !room.is_favorite
            })
    };

    @action
    removeFavoriteRoom = (room) => {
        http.post(`/favorite-room/${room.id}/remove`)
            .then(() => {
                room.is_favorite = !room.is_favorite
            })
    };

    clickHistoryButton = () => {
        const url = `/booking/cabinet`;
        if (this._authStore.checkAuth()) {
            this._routerStore.history.push(url)
        } else {
            this._authStore.authAndRedirect(url)
        }
    };

    clickRoomFavButton = (room) => {
        if (room.is_favorite) {
            this.removeFavoriteRoom(room)
        } else {
            this.addFavoriteRoom(room)
        }
    };
}

export {BookingStudioPageStore};
